// extracted by mini-css-extract-plugin
module.exports = {"pageClose":"index-module--pageClose--u2T00","pageCloseRibbon":"index-module--pageCloseRibbon--2OMRd"};